import messages from "@/messages/fr.json";

type MessageTree = Record<string, unknown>;

function resolvePath(tree: MessageTree, path: string): string | undefined {
  const keys = path.split(".");
  let current: unknown = tree;

  for (const key of keys) {
    if (!current || typeof current !== "object" || !(key in current)) {
      return undefined;
    }
    current = (current as MessageTree)[key];
  }

  return typeof current === "string" ? current : undefined;
}

export function translate(
  path: string,
  values?: Record<string, string | number>,
): string {
  const template = resolvePath(messages as MessageTree, path) ?? path;

  if (!values) {
    return template;
  }

  return Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
    template,
  );
}

export function getTranslations(namespace: string) {
  return (key: string, values?: Record<string, string | number>) =>
    translate(`${namespace}.${key}`, values);
}
